export default __webpack_public_path__ + "static/media/intro-bg-min.1098453e.png";